import { render, staticRenderFns } from "./SocialAuthenticationBtn.vue?vue&type=template&id=0b7c80c5&scoped=true&"
import script from "./SocialAuthenticationBtn.vue?vue&type=script&lang=ts&"
export * from "./SocialAuthenticationBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SocialAuthenticationBtn.vue?vue&type=style&index=0&id=0b7c80c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c80c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
